module.exports = __webpack_public_path__ + "static/media/logo-whatsapp.cc7ed840.png";